export default __webpack_public_path__ + "static/media/Greatsword of the Death Master.d6cd4547.jpg";